"use client"

import Link from "next/link"
import { useAuth } from "@/components/hooks/use-auth"
import { GET_STARTED_URL } from "../constants"

const NAV = [
  { label: "Product", href: "/features" },
  { label: "For agents", href: "/agents" },
  { label: "Integrations", href: "/integrations" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
] as const

const DOCS_URL = "https://docs.aient.ai"

function Arrow({ name }: { name: "ne" | "r" }) {
  return (
    <svg className="sg" aria-hidden="true">
      <use href={`#sg-${name}`} />
    </svg>
  )
}

function DocsLink({ arrow }: { arrow: "icon" | "text" }) {
  return (
    <a href={DOCS_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-docs">
      Docs {arrow === "icon" ? <Arrow name="ne" /> : "↗"}
      <span className="vh"> (opens in a new tab)</span>
    </a>
  )
}

/**
 * Header and the phone menu. Behaviour (hide on scroll, the modal menu, focus handling) is attached
 * by HomeBehaviour, which looks for #hdr, #mpanel and the .menu buttons.
 */
export function HomeHeader() {
  const { user } = useAuth()
  return (
    <>
      <a className="skip" href="#main" data-testid="home-skip-to-content">
        Skip to content
      </a>
      <header className="hdr" id="hdr">
        <div className="bar">
          <Link className="lockup" href="/" aria-label="Aient, home" data-testid="home-aient">
            <svg aria-hidden="true">
              <use href="#burst" />
            </svg>
            Aient
          </Link>
          <nav aria-label="Main navigation">
            {NAV.map((item) => (
              <Link key={item.href} href={item.href} data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}>
                {item.label}
              </Link>
            ))}
            <DocsLink arrow="icon" />
          </nav>
          <div className="acts">
            {user ? (
              <Link className="b1 sm" href="/dashboard" data-testid="home-dashboard">
                Dashboard
              </Link>
            ) : (
              <>
                <Link className="login" href="/auth/login" data-testid="home-log-in">
                  Log in
                </Link>
                <Link className="b1 sm" href={GET_STARTED_URL} data-testid="home-sign-up">
                  Start free
                </Link>
              </>
            )}
            <button type="button" className="menu" aria-expanded="false" aria-controls="mpanel" data-testid="home-menu">
              Menu
            </button>
          </div>
        </div>
      </header>
      <div className="mpanel" id="mpanel" role="dialog" aria-modal="true" aria-label="Menu" hidden>
        <button type="button" className="menu" data-close>
          Close
        </button>
        <nav aria-label="Mobile navigation" className="mnav">
          {NAV.map((item) => (
            <Link key={item.href} href={item.href} data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}>
              {item.label}
            </Link>
          ))}
          <DocsLink arrow="text" />
        </nav>
        <button type="button" className="rmt" data-rm aria-pressed="false" style={{ fontSize: "var(--s)" }}>
          <i aria-hidden="true">
            <svg className="sg" style={{ width: "14px", height: "14px" }}>
              <use href="#sg-tick" />
            </svg>
          </i>
          Reduce motion
        </button>
      </div>
    </>
  )
}
